
import React from 'react';
import { Star, Check, Cat, PawPrint } from 'lucide-react';
import ReserveButton from '../ReserveButton';

const BookingCTA: React.FC = () => {
  return (
    <div className="container mx-auto px-4 text-center">
      <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-6 text-white">
        Ready to walk in the pawprints of history?
      </h2>
      <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-6 font-opensans">
        Secure your spot today for a unique walking experience through NYC's feline history.
      </p>
      
      <div className="flex flex-col items-center">
        <ReserveButton 
          variant="primary"
          className="min-w-[300px] min-h-[56px]"
        />
        
        <div className="flex flex-col gap-2 mt-2 text-center max-w-md mx-auto">
          <div className="bg-white/20 backdrop-blur-sm px-5 py-2.5 rounded-full inline-block mx-auto">
            <span className="text-white font-semibold">$40 (avg. NYC walking tours: $55)</span>
          </div>
          
          <div className="flex items-center justify-center text-white/90 text-sm gap-1">
            <Star size={14} className="text-gold" aria-hidden="true" />
            <Star size={14} className="text-gold" aria-hidden="true" />
            <Star size={14} className="text-gold" aria-hidden="true" />
            <Star size={14} className="text-gold" aria-hidden="true" />
            <Star size={14} className="text-gold" aria-hidden="true" />
            <span className="ml-1">98% of guests rate our tours 5 stars</span>
          </div>
          
          <p className="text-sm italic text-white/80 mt-1">
            Tours are limited to small groups for a personalized experience
          </p>
          
          <p className="text-sm text-white/90 mt-2 flex items-center justify-center flex-wrap">
            <Cat size={16} className="mr-2 flex-shrink-0" aria-hidden="true" />
            <span>The only tours in NYC where you'll meet other cat lovers while exploring feline history</span>
            <PawPrint size={16} className="ml-2 flex-shrink-0" aria-hidden="true" />
          </p>
        </div>
      </div>
      
      {/* Enhanced trust badges with better visual design */}
      <div className="mt-8 pt-4 border-t border-white/20 max-w-md mx-auto">
        <p className="text-white/90 font-montserrat mb-2">Why Choose Our Tours</p>
        <div className="flex flex-wrap justify-center items-center gap-3 mt-2">
          <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-2 rounded-lg text-white/90 text-sm">
            <Check size={16} className="text-accent mr-2" aria-hidden="true" />
            <span>Expert Guides</span>
          </div>
          <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-2 rounded-lg text-white/90 text-sm">
            <Check size={16} className="text-accent mr-2" aria-hidden="true" />
            <span>Small Groups</span>
          </div>
          <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-2 rounded-lg text-white/90 text-sm">
            <Check size={16} className="text-accent mr-2" aria-hidden="true" />
            <span>Unique Stories</span>
          </div>
        </div>
      </div>
    </div>
  );
};

// Use React.memo to prevent unnecessary re-renders
export default React.memo(BookingCTA);
